"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMoreThanOneDayBeforeDeparture = exports.hasNoReturnTickets = exports.hasNoDepartTickets = exports.hasReturnTickets = exports.hasDepartTickets = exports.isTourSold = void 0;
var tslib_1 = require("tslib");
var difference_in_hours_1 = tslib_1.__importDefault(require("date-fns/difference_in_hours"));
var parseDateString_1 = require("sletat-common-utils/lib/date/lib/parseDateString");
var models_1 = require("../../module/tourActualization/models");
var Tour_1 = require("../../Tour");
function isTourSold(tour) {
    if (!tour) {
        return false;
    }
    return tour.isHotelInStop || hasNoDepartTickets(tour) || hasNoReturnTickets(tour);
}
exports.isTourSold = isTourSold;
function hasDepartTickets(tour) {
    if (!tour) {
        return false;
    }
    var ticketsIncluded = tour.flightInfo.ticketsInPrice;
    var hasDepartEconomTicket = tour.flightInfo.economyTicketsTo === Tour_1.TicketsAvailability.InStock;
    return ticketsIncluded && hasDepartEconomTicket;
}
exports.hasDepartTickets = hasDepartTickets;
function hasReturnTickets(tour) {
    if (!tour) {
        return false;
    }
    var ticketsIncluded = tour.flightInfo.ticketsInPrice;
    var hasReturnEconomTicket = tour.flightInfo.economyTicketsBack === Tour_1.TicketsAvailability.InStock;
    return ticketsIncluded && hasReturnEconomTicket;
}
exports.hasReturnTickets = hasReturnTickets;
function hasNoDepartTickets(tour) {
    if (!tour) {
        return false;
    }
    var ticketsIncluded = tour.flightInfo.ticketsInPrice;
    var hasNoDepartTickets = tour.flightInfo.economyTicketsTo === Tour_1.TicketsAvailability.OutOfStock &&
        tour.flightInfo.ticketBusinessTo === Tour_1.TicketsAvailability.OutOfStock;
    return ticketsIncluded && hasNoDepartTickets;
}
exports.hasNoDepartTickets = hasNoDepartTickets;
function hasNoReturnTickets(tour) {
    if (!tour) {
        return false;
    }
    var ticketsIncluded = tour.flightInfo.ticketsInPrice;
    var hasNoReturnTickets = tour.flightInfo.economyTicketsBack === Tour_1.TicketsAvailability.OutOfStock &&
        tour.flightInfo.ticketBusinessBack === Tour_1.TicketsAvailability.OutOfStock;
    return ticketsIncluded && hasNoReturnTickets;
}
exports.hasNoReturnTickets = hasNoReturnTickets;
function isMoreThanOneDayBeforeDeparture(data) {
    var tourHasResources = !!data.resources && !!data.resources.length && !!data.resourcesData && !!data.resourcesData.length;
    if (!tourHasResources) {
        var exactDepartDate_1 = (0, parseDateString_1.parseDateString)(data.tour.departDate, 'DD.MM.YYYY');
        return (0, difference_in_hours_1.default)(exactDepartDate_1, new Date()) > 24;
    }
    var resourceDateName = 'DATE';
    var resourseTimeName = 'START_TIME';
    var resourceDateTimeName = 'START_DATETIME';
    var dateResourceItem = null;
    var timeResourceItem = null;
    var dateTimeResourseItem = null;
    var exactDepartTime = ['00', '00'];
    var exactDepartDate = (0, parseDateString_1.parseDateString)(data.tour.departDate, 'DD.MM.YYYY');
    var departFlight = (data.resources || []).filter(function (r) { return r.isChecked && r.type === models_1.ResourceTypes.flightTo; })[0];
    if (departFlight) {
        dateResourceItem =
            data.resourcesData.filter(function (rd) { return rd.name === resourceDateName && rd.resourceId === departFlight.id; })[0] || null;
        timeResourceItem =
            data.resourcesData.filter(function (rd) { return rd.name === resourseTimeName && rd.resourceId === departFlight.id; })[0] || null;
        dateTimeResourseItem =
            data.resourcesData.filter(function (rd) { return rd.name === resourceDateTimeName && rd.resourceId === departFlight.id; })[0] || null;
    }
    if (dateResourceItem) {
        exactDepartDate = (0, parseDateString_1.parseDateString)(dateResourceItem.value, 'DD.MM.YYYY');
    }
    if (timeResourceItem) {
        exactDepartTime = timeResourceItem.value.split(':');
    }
    else if (dateTimeResourseItem) {
        exactDepartTime = dateTimeResourseItem.value.split(' ')[1].split(':');
    }
    if (exactDepartDate) {
        exactDepartDate.setHours(parseInt(exactDepartTime[0], 10));
        exactDepartDate.setMinutes(parseInt(exactDepartTime[1], 10));
    }
    return !!exactDepartDate && (0, difference_in_hours_1.default)(exactDepartDate, new Date()) > 24;
}
exports.isMoreThanOneDayBeforeDeparture = isMoreThanOneDayBeforeDeparture;
